module.exports = __webpack_public_path__ + "static/media/icon_registry.47badf7c.png";